import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core';
import { Grid, Button } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import { login } from '../utils/auth';
import { redirectURL } from '../reducers/redirectURLSlice';
import { getUserInfo, setUserLanguage } from '../utils/language';
import { addAlert } from '../actions/alerts.action';
import { setObjectiveLicences } from '../reducers/licencesSlice';
import { trimWhitespaces } from '../utils/strings';
import Background from '../assets/images/loginBackground.png';

const Login = props => {
  const { t } = useTranslation();
  const url = useSelector(redirectURL);
  const [ loginName, setLoginName ] = useState('');
  const [ password, setPassword ] = useState('');

  const dispatch = useDispatch();

  useEffect( () => {
    if (localStorage.getItem('jwtToken')) {
      props.history.push(url);
    }
  }, [ props.history, url ]);

  const handleKeyPress = event => {
    if (event.charCode === 13) {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    try {
      await login({ loginName, password });

      const { language, hasValidObjectiveManagementLicence } = await getUserInfo();
      dispatch(setObjectiveLicences(hasValidObjectiveManagementLicence));
      setUserLanguage(language);
      props.history.push(url);
    } catch (error) {
      const { message } = error;
      dispatch(addAlert({ message: `login.alert.${ message }`, severity: 'error' }));
    }
  };

  const handleOnChangeEmployeeId = event => setLoginName(trimWhitespaces(event.target.value));
  const handleOnChangePassword = event => setPassword(event.target.value);

  const useStyles = makeStyles({
    root: {
      justify: 'center',
      minHeight: '100vh',
      backgroundImage: `url(${Background})`,
      backgroundSize: 'contain',
      backgroundPosition: '-180px'
    },
    paper: {
      padding: '20px',
      width: '250px'
    },
    textField: {
      width: '100%',
      marginTop: '10px',
      marginBottom: '10px'
    }
  });

  const classes = useStyles();

  return (
    <Grid container className={ classes.root } justifyContent="center" alignItems="center">
      <Paper className={ classes.paper }>
        <Grid container direction={ 'column' }>
          <Typography variant="h5" component="h3">
            {t('login.title')}
          </Typography>
          <TextField
            label={ t('login.label.user_name') }
            className={ classes.textField }
            onChange={ handleOnChangeEmployeeId }
            value={ loginName }
            onKeyPress={  handleKeyPress }
          />
          <TextField
            type="password"
            label={ t('login.label.password') }
            className={ classes.textField }
            onChange={ handleOnChangePassword }
            onKeyPress={ handleKeyPress }
          />
          <Link href="/forgottenPassword" color="inherit" variant="body2">
            {t('login.button.forgotten_password')}
          </Link>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end">
          <Button onClick={ handleLogin } color='primary'>
            {t('login.button.login')}
          </Button>
        </Grid>
      </Paper>
    </Grid>
  );
};

export default Login;
